var _defs, _circle, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path, _path2, _line9, _line10, _line11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeather(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 64 64",
    width: "64pt",
    height: "64pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_ESqaX8K9FMSz5bcwQyejloDVn76x3bPN"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_ESqaX8K9FMSz5bcwQyejloDVn76x3bPN)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 39.8,
    cy: 22,
    r: 12.590000000000002,
    fill: "rgb(255,255,255)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 39.8,
    y1: 2,
    x2: 39.8,
    y2: 6.44
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 39.8,
    y1: 37.56,
    x2: 39.8,
    y2: 42
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 19.8,
    y1: 22,
    x2: 24.25,
    y2: 22
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 55.36,
    y1: 22,
    x2: 59.8,
    y2: 22
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 25.66,
    y1: 7.86,
    x2: 28.8,
    y2: 11
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 50.8,
    y1: 33,
    x2: 53.94,
    y2: 36.14
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 25.66,
    y1: 36.14,
    x2: 28.8,
    y2: 33
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 50.8,
    y1: 11,
    x2: 53.94,
    y2: 7.86
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: " M 23.5 15.9 C 29.997 15.887 35.965 19.476 39 25.22 C 44 22.297 50.296 22.82 54.745 26.529 C 59.194 30.238 60.841 36.337 58.865 41.782 C 56.888 47.226 51.712 50.848 45.92 50.84 L 23.5 50.9 C 13.835 50.9 6 43.065 6 33.4 C 6 23.735 13.835 15.9 23.5 15.9 Z ",
    fill: "rgb(255,255,255)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_0",
    x1: 0.7261818181818183,
    y1: 0.6490909090909069,
    x2: 0.08436363636363642,
    y2: 0.2265454545454521,
    gradientTransform: "matrix(7.4,-26.486,26.486,7.4,28.948,46.626)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "2%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(255,255,255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0,
    style: {
      stopColor: "rgb(255,255,255)"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: " M 42.19 50.326 C 34.882 48.284 30.606 40.692 32.648 33.383 C 34.69 26.074 42.281 21.798 49.59 23.84 C 56.899 25.882 61.175 33.474 59.133 40.783 C 57.091 48.092 49.499 52.368 42.19 50.326 Z ",
    fill: "url(#_lgradient_0)"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 32.5,
    y1: 55.5,
    x2: 32.5,
    y2: 62.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 26.5,
    y1: 53.5,
    x2: 26.5,
    y2: 60.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 38.5,
    y1: 53.5,
    x2: 38.5,
    y2: 60.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeather);
export default __webpack_public_path__ + "static/media/Icon_weather.e3be26ed39efcf1e22f450403da93c69.svg";
export { ForwardRef as ReactComponent };